<template>
<!-- footer -->
<div class="container">
  <footer class="py-3 my-4">
    <ul class="nav justify-content-center border-bottom pb-3 mb-3">
      <li id="home" class="nav-item" :class="{active : activeId == 'home'}"><router-link class="nav-link px-2 text-muted" to="/">首页</router-link></li>
      <li id="category" class="nav-item" :class="{active : activeId == 'category'}"><router-link class="nav-link px-2 text-muted" to="/Category">产品</router-link></li>
      <li id="gallery" class="nav-item" :class="{active : activeId == 'gallery'}"><router-link class="nav-link px-2 text-muted" to="/Gallery">相册</router-link></li>
      <li id="shopping" class="nav-item" :class="{active : activeId == 'shopping'}"><router-link class="nav-link px-2 text-muted" to="/Shopping">购买指南</router-link></li>
      <li id="about" class="nav-item" :class="{active : activeId == 'about'}"><router-link class="nav-link px-2 text-muted" to="/About">关于我们</router-link></li>
    </ul>
    <p class="text-center text-muted">&copy; 2022 3fishspecial.ca</p>
  </footer>
</div>
</template>
<script>
  import $ from 'jquery'
  export default {
    name: 'Footer',
    props: {
      activeId:{type:String, default:'home'}
    },
    setup() {
        //called by app.vue
        const chgActiveItem = (id) => { 
          console.log(id)
          $('ul.nav li').removeClass('active')
          $('#'+id).addClass('active')
        }

        return {chgActiveItem}
    }
  };
</script>
<style lang="scss" scoped>
li.active {
  border: 1px solid #666666;
  background: #3737bb;
  a {color: #fff !important;}
}
</style>